import React from 'react';
import styles from "./PaymentWidgetContainer.module.scss"

export const PaymentWidgetContainer = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles.container}>
      { children }
    </div>
  );
}